<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" slot="icon-only" (click)="back()">
        <ion-icon name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ countItemName.value ? countItemName.value : 'New Inventory Count' }} {{
      inventoryCountID ? (isFullCount === 0 ? '(Partial Count)' : '(Full
      Count)') : null }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask> -->

  <!-- <salonmonster-click-retry *ngIf="errorOccurredWhileLoadingProductInfo" (click)="refresh()"></salonmonster-click-retry> -->

  <!-- <form *ngIf='inventoryCount && !isLoading' [formGroup]='inventoryCountForm' (ngSubmit)="onInventoryCountSave()"> -->
  <form [formGroup]="countItemForm">
    <ion-grid class="review-content">
      <ion-row>
        <ion-col>
          <ion-label position="stacked">Count Name</ion-label>
          <ion-input
            class="sm-input-border"
            theme="light"
            type="text"
            name=""
            formControlName="countItemName"
            required="required"
          ></ion-input>
          <ion-item
            [hidden]="countItemName.valid || (countItemName.pristine && !submitted)"
            lines="none"
          >
            <p *ngIf="countItemName.hasError('required')" class="sm-error">
              Oops, a Count Name is required.
            </p>
          </ion-item>
        </ion-col>

        <ion-col>
          <ion-label position="stacked">Date</ion-label>

          <div
            class="ng-untouched ng-pristine ng-valid ion-untouched ion-pristine ion-valid sc-ion-input-md-h sc-ion-input-md-s md has-value hydrated"
          >
            <input
              [ngClass]="{'native-input': true, 'sc-ion-input-md': !isIOS, 'sc-ion-input-ios': isIOS}"
              theme="light"
              placeholder="YY-MM-DD"
              formControlName="countItemDate"
              [owlDateTimeTrigger]="dt0"
              [owlDateTime]="dt0"
            />
          </div>
        </ion-col>
      </ion-row>
      <owl-date-time [pickerType]="'calendar'" #dt0></owl-date-time>

      <ion-row>
        <ion-col>
          <ion-label position="stacked">Notes</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="notes"
            class="sm-input-border"
            clearInput
          ></ion-input>
        </ion-col>
      </ion-row>

      <ion-buttons class="tab-group" *ngIf="inventoryCountID == 0 || !inventoryCountID">
        <ion-button
          [ngClass]="{ 'tab-checked': isFullCount == 1 }"
          class="tab-button"
          (click)="isFullCount = 1; mapPaginatorValue()"
          >Full Count</ion-button
        >
        <ion-button
          [ngClass]="{ 'tab-checked': isFullCount == 0 }"
          class="tab-button"
          (click)="isFullCount = 0; stats = []"
          >Partial Count</ion-button
        >
      </ion-buttons>

      <div style="margin: auto; margin-top: 50px" *ngIf="isLoading == true">
        <ion-spinner icon="crescent" color="primary"></ion-spinner>
      </div>
      <div *ngIf="isLoading == false">
        <div
          class="page-content"
          style="height: 60%; width: 100%; margin: auto"
        >
          <p-table
            #table
            styleClass="sticky-table"
            dataKey="id"
            [autoLayout]="true"
            [value]="stats"
            [loading]="isLoading"
            [responsive]="true"
            [totalRecords]="stats.length"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          >
            <ng-template pTemplate="header" let-columns>
              <tr *ngIf="!(isFullCount==0 && stats.length===0)">
                <th [pSortableColumn]="'name'" class="inventoryTableHeader">
                  Product
                </th>
                <th [pSortableColumn]="'brand'" class="inventoryTableHeader">
                  Brand
                </th>
                <th [pSortableColumn]="'size'" class="inventoryTableHeader">
                  Size
                </th>
                <th
                  [pSortableColumn]="'expectedCount'"
                  class="inventoryTableHeader"
                >
                  Expected
                </th>
                <th class="inventoryTableHeader">Actual</th>
                <th
                  *ngIf="isFullCount==0 && !inventoryCountID"
                  class="inventoryTableHeader"
                ></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-stat let-columns="columns">
              <tr>
                <td><b>{{ stat.name}}</b></td>
                <td><span>{{ stat.brand }}</span></td>
                <td><span>{{ stat.size }}</span></td>
                <td><span>{{ stat.expectedCount }}</span></td>
                <td>
                  <ion-input
                    [disabled]="countItemStatusID.value == 1"
                    class="sm-input-border actual-count"
                    style="max-width: 200px"
                    type="number"
                    [(ngModel)]="stat.actualCount"
                    [ngModelOptions]="{standalone: true}"
                    clearInput
                  ></ion-input>
                </td>
                <td *ngIf="isFullCount==0 && !inventoryCountID">
                  <ion-button
                    class="btn"
                    fill="clear"
                    expand="block"
                    color="danger"
                    (click)="remove(stat)"
                    >Delete</ion-button
                  >
                </td>
              </tr>
            </ng-template>
          </p-table>

          <ion-button
            class="ion-margin"
            *ngIf="isFullCount==0 && !inventoryCountID"
            style="height: 40px; width: 200px; margin-left: 1%"
            fill="outline"
            expand="block"
            color="primary"
            (click)="showProductList()"
          >
            Add Product(s)
        </ion-button>
        </div>
      </div>
    </ion-grid>
  </form>

</ion-content>
<!-- bottom Delete & Submit Buttons -->
<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row *ngIf="(countItemStatusID.value && countItemStatusID.value !== 1) || !inventoryCountID">
        <ion-col>
          <ion-button
            fill="outline"
            expand="block"
            color="primary"
            (click)="inventorySave(2)"
          >
            Save + pause count
          </ion-button>
        </ion-col>

        <ion-col>
          <ion-button expand="block" (click)="inventorySave(1)">
            Complete
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="countItemStatusID.value && countItemStatusID.value === 1">
        <ion-col>
          <ion-button expand="block" (click)="back()">
            Back
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
